export function isEmailValid(value) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(value);
}

export function isPhoneValid(value) {
  return /^(0|[0-9]*$)/i.test(value);
}
